import type { IconData } from '@stacksjs/iconify-core'

export const otherUiHandMove: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M14 3a1 1 0 1 0-2 0v4h-1.34V1a1 1 0 1 0-2 0v6H7.33V2a1 1 0 0 0-2 0v7H4V7a2 2 0 0 0-2-2v5a6 6 0 0 0 12 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiHandMove
